"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.split = exports.parseResponseHeaders = exports.lastItem = exports.uniqueGUID = exports.shallowEqual = void 0;
/**
 * Shallow compare two values.  If the values are primitives, a simple equality check is performed.
 * If they are objects/arrays we go 1 level in and do reference/value equality.
 *
 * @param a One of the values to compare
 * @param b The other value to compare
 */
exports.shallowEqual = function (a, b) {
    var e_1, _a;
    if (a && b && typeof a === "object" && typeof b === "object") {
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) {
            return false;
        }
        try {
            for (var aKeys_1 = __values(aKeys), aKeys_1_1 = aKeys_1.next(); !aKeys_1_1.done; aKeys_1_1 = aKeys_1.next()) {
                var key = aKeys_1_1.value;
                if (!bKeys.includes(key) || a[key] !== b[key]) {
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (aKeys_1_1 && !aKeys_1_1.done && (_a = aKeys_1.return)) _a.call(aKeys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return true;
    }
    return a === b;
};
function uniqueGUID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return (s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4());
}
exports.uniqueGUID = uniqueGUID;
exports.lastItem = function (array) { return array[array.length - 1]; };
function parseResponseHeaders(response) {
    var headers = {};
    response.headers &&
        response.headers.forEach(function (val, key) {
            headers[key] = val;
        });
    return headers;
}
exports.parseResponseHeaders = parseResponseHeaders;
exports.split = function (data, pageSize) {
    var split = [];
    for (var index = 0; index < data.length; index += pageSize) {
        split.push(data.slice(index, index + pageSize));
    }
    return split;
};
//# sourceMappingURL=utils.js.map